// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RaiseTicketWrapperCmp from "./RaiseTicketWrapperCmp.bs.js";

function NonOrderRelatedTicketRootCmp(Props) {
  return React.createElement(RaiseTicketWrapperCmp.make, {
              crn: undefined
            });
}

var make = NonOrderRelatedTicketRootCmp;

export {
  make ,
  
}
/* react Not a pure module */
